<template>
  <div>
    <div class="table-container">
      <el-table
        :data="rows"
        stripe
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          v-for="col in columns"
          :key="col.key"
          :label="col.label"
          :prop="col.key"
          :align="col.align || 'left'"
          :min-width="col.flex * 80"
        >
          <template slot-scope="scope">
            <div v-if="col.type === 'fund'" class="fund-info">
              <div class="fund-name">{{ scope.row.name }}</div>
              <div class="fund-code-line">
                <span class="fund-code">{{ scope.row.code }}</span>
                <el-tag
                  :type="scope.row.tagType === 'open' ? 'primary' : 'success'"
                  size="mini"
                >
                  {{ scope.row.tag }}
                </el-tag>
              </div>
            </div>
            <span
              v-else-if="col.type === 'premium'"
              :class="['premium-value', scope.row.premiumClass]"
            >
              {{ scope.row.premium }}
            </span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
        
        <!-- 操作列：查看历史溢价情况 -->
        <!-- <el-table-column
          label="操作"
          align="center"
          width="80"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleViewHistory(scope.row)"
            >
              历史溢价
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <div class="data-note">数据仅供参考</div>
    </div>

    <el-alert
      title="温馨提示"
      type="warning"
      :closable="false"
      style="margin-top: 20px"
    >
      <div class="warning-list">
        <p>1. 数据仅供参考，不构成投资建议！</p>
        <p>2. 数据有一定的延时性，请关注更新时间！</p>
        <p>3. 估值可能会有一定的误差，请谨慎参考！</p>
      </div>
    </el-alert>
  </div>
</template>

<script>
export default {
  name: 'FundTable',
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleViewHistory(row) {
      this.$message.info('功能开发中，敬请期待')
    }
  }
}
</script>

<style scoped>
.table-container {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.fund-info .fund-name {
  font-size: 13px;
  color: #222;
  margin-bottom: 4px;
  font-weight: 600;
}

.fund-code-line {
  display: flex;
  align-items: center;
  gap: 6px;
}

.fund-code {
  font-size: 11px;
  color: #5a7bb5;
}

.premium-value {
  color: #ff5b41;
  font-weight: 600;
  font-size: 13px;
}

.premium-value.negative {
  color: #18a85a;
}

.data-note {
  text-align: center;
  color: #b0b3bd;
  font-size: 11px;
  padding: 12px 0;
  margin-top: 8px;
}

.warning-list p {
  margin: 6px 0;
  line-height: 1.6;
  font-size: 12px;
}
</style>

